import React from "react";

import { getDefaultTab } from "@/utils/getDefaultTab";
import { useTranslation } from "next-i18next";
import Head from "next/head";
import { useRouter } from "next/router";
import { theme } from "~styles/theme/main/theme";

import { SwipeableNavigation } from "@/components/blocks/global/swipeable-navigation/SwipeableNavigation";
import Layout from "@/components/layouts/layout/Layout";
import { searchPageNavItems } from "@/components/pages/search/searchPageNavItems";
import { Box } from "@mui/material";

const TABS = {
  recipes: 0,
  favourites: 1
} as const;

export const SearchPage = (): JSX.Element => {
  const { t } = useTranslation("searchpage");
  const router = useRouter();
  const defaultTab = getDefaultTab(router, TABS);

  return (
    <Layout>
      <Head>
        <meta name="theme-color" content={theme.palette.primary.main} />
      </Head>
      <Box flex={1} overflow={"hidden"}>
        <SwipeableNavigation
          items={searchPageNavItems(t)}
          defaultState={defaultTab}
        />
      </Box>
    </Layout>
  );
};
